import { render, staticRenderFns } from "./bucket-details.html?vue&type=template&id=43e8118c&scoped=true&external"
import script from "./bucket-details.js?vue&type=script&lang=js&external"
export * from "./bucket-details.js?vue&type=script&lang=js&external"
import style0 from "./bucket-details.scss?vue&type=style&index=0&id=43e8118c&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43e8118c",
  null
  
)

export default component.exports